import React, { useEffect, useState, useRef, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function BonusGrid() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const scrollToIndex = (index: number) => {
    if (scrollRef.current) {
      const cardWidth = scrollRef.current.offsetWidth;
      scrollRef.current.scrollTo({
        left: index * cardWidth,
        behavior: 'smooth'
      });
      setActiveIndex(index);
    }
  };
  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollLeft = scrollRef.current.scrollLeft;
      const cardWidth = scrollRef.current.offsetWidth;
      const newIndex = Math.round(scrollLeft / cardWidth);
      if (newIndex !== activeIndex) {
        setActiveIndex(newIndex);
      }
    }
  };
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        const nextIndex = (activeIndex + 1) % bonuses.length;
        scrollToIndex(nextIndex);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [activeIndex, isAutoPlaying]);
  const bonuses = [{
    id: 1,
    title: 'Guía de Marketing para Vender',
    description: 'Aprendé a posicionar tus creaciones en redes sociales y atraer clientes dispuestos a pagar lo que tu trabajo vale.',
    image: 'https://cdn.magicpatterns.com/uploads/7mu24rk948ds1j8kpWPExD/Captura_de_pantalla_2026-03-25_153752.png',
    originalPrice: '$12.990'
  }, {
    id: 2,
    title: 'Decoración Moderna e Iluminación',
    description: 'Secretos de interiorismo para que tus mesas no solo sean muebles, sino piezas centrales de decoración de lujo.',
    image: 'https://cdn.magicpatterns.com/uploads/wgHiN7aeoAdmxtKmrcz2G8/decoracion.webp',
    originalPrice: '$12.990'
  }, {
    id: 3,
    title: 'Precios, Costos y Ventas',
    description: 'Planilla profesional para calcular materiales, mano de obra y margen de ganancia sin perder dinero.',
    image: 'https://cdn.magicpatterns.com/uploads/qXMECcj9NkgeYFBaiRrXrD/costos.webp',
    originalPrice: '$12.990'
  }, {
    id: 4,
    title: 'Diseños y Trabajo Profesional con Luces LED',
    description: 'Guía técnica sobre voltajes, conexiones y tipos de tiras LED para lograr el efecto infinito perfecto.',
    image: 'https://cdn.magicpatterns.com/uploads/wm6XoazqL2ndD4QeTffvWy/luces_led.webp',
    originalPrice: '$14.990'
  }, {
    id: 5,
    title: 'Taller de Madera - Diseño sin Límites',
    description: 'Domina las herramientas y ensambles necesarios para construir estructuras sólidas y duraderas.',
    image: 'https://cdn.magicpatterns.com/uploads/4UQzw9rRd7mvJqvw92GwnL/book_5.jpg',
    originalPrice: '$14.990'
  }];
  // Calculate total value
  const totalValue = bonuses.reduce((sum, bonus) => {
    const price = parseInt(bonus.originalPrice.replace(/[$.]/g, ''));
    return sum + price;
  }, 0);
  return <section className="py-12 px-4 relative z-10 bg-[#0a0514] overflow-hidden border-y border-[#27272a]" data-id="element-26">
      <div className="max-w-7xl mx-auto" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#130a2a] border border-[#27272a] text-[#f5c518] text-sm font-bold mb-6 tracking-wide" data-id="element-29">
            🎁 OFERTA POR TIEMPO LIMITADO
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight leading-[1.1]" data-id="element-30">
            BONUS EXCLUSIVOS
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-400 max-w-2xl mx-auto font-normal mb-4" data-id="element-31">
            Llevate estos 5 ebooks GRATIS con tu compra de hoy
          </motion.p>
        </div>

        {/* Bonus Carousel Container */}
        <div className="relative group/carousel" onMouseEnter={() => setIsAutoPlaying(false)} onMouseLeave={() => setIsAutoPlaying(true)} data-id="element-32">
          {/* Navigation Arrows */}
          <div className="absolute top-1/2 -left-2 md:-left-12 -translate-y-1/2 z-20 block" data-id="element-33">
            <button onClick={() => {
            setIsAutoPlaying(false);
            scrollToIndex(Math.max(0, activeIndex - 1));
          }} disabled={activeIndex === 0} className={`p-3 rounded-full bg-[#130a2a] border border-[#27272a] text-white transition-all ${activeIndex === 0 ? 'opacity-30 cursor-not-allowed' : 'hover:bg-[#1a1135] hover:border-[#f5c518] hover:text-[#f5c518]'}`} aria-label="Anterior" data-id="element-34">
              <ChevronLeft className="w-6 h-6" data-id="element-35" />
            </button>
          </div>

          {/* Navigation Arrows */}
          <div className="absolute top-1/2 -right-2 md:-right-12 -translate-y-1/2 z-20 block" data-id="element-36">
            <button onClick={() => {
            setIsAutoPlaying(false);
            scrollToIndex(Math.min(bonuses.length - 1, activeIndex + 1));
          }} disabled={activeIndex === bonuses.length - 1} className={`p-3 rounded-full bg-[#130a2a] border border-[#27272a] text-white transition-all ${activeIndex === bonuses.length - 1 ? 'opacity-30 cursor-not-allowed' : 'hover:bg-[#1a1135] hover:border-[#f5c518] hover:text-[#f5c518]'}`} aria-label="Siguiente" data-id="element-37">
              <ChevronRight className="w-6 h-6" data-id="element-38" />
            </button>
          </div>

          {/* Scrollable Area */}
          <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory no-scrollbar gap-6 pb-8" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-39">
            {bonuses.map((bonus, index) => <div key={bonus.id} className="min-w-full md:min-w-[calc(50%-12px)] lg:min-w-[calc(33.333%-16px)] snap-center" data-id="element-40">
                <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5
            }} className="h-full bg-[#130a2a] border border-[#27272a] rounded-3xl p-6 md:p-8 hover:border-[#3f3f46] transition-all duration-500 hover:shadow-[0_20px_60px_rgba(0,240,255,0.15)] group flex flex-col" data-id="element-41">
                  {/* Bonus Badge */}
                  <div className="inline-flex self-start items-center gap-2 px-3 py-1 rounded-full bg-[#f5c518]/10 border border-[#f5c518]/30 text-[#f5c518] text-xs font-bold mb-4 tracking-wider" data-id="element-42">
                    BONUS {bonus.id}
                  </div>

                  {/* Title */}
                  <h3 className="text-white font-bold text-xl md:text-2xl mb-3 leading-tight group-hover:text-[#f5c518] transition-colors" data-id="element-43">
                    {bonus.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-400 text-[15px] md:text-base mb-6 leading-relaxed flex-grow" data-id="element-44">
                    {bonus.description}
                  </p>

                  {/* Book Image */}
                  <div className="relative mb-6 overflow-hidden rounded-2xl group-hover:scale-105 transition-transform duration-300" data-id="element-45">
                    <img src={bonus.image} alt={bonus.title} width={400} height={400} loading="lazy" decoding="async" className="w-full h-auto object-cover" data-id="element-46" />
                  </div>

                  {/* Pricing */}
                  <div className="text-center mt-auto" data-id="element-47">
                    <p className="text-gray-500 text-sm font-medium mb-2" data-id="element-48">
                      VALOR NORMAL:
                    </p>
                    <p className="text-2xl text-gray-600 line-through font-bold decoration-red-500/60 decoration-4 mb-3" data-id="element-49">
                      {bonus.originalPrice} ARS
                    </p>
                    <div className="bg-gradient-to-r from-[#f5c518] to-[#d97706] text-black font-black text-xl py-3 px-6 rounded-xl uppercase tracking-wide" data-id="element-50">
                      GRATIS HOY
                    </div>
                  </div>
                </motion.div>
              </div>)}
          </div>

          {/* Indicator Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-51">
            {bonuses.map((_, index) => <button key={index} onClick={() => {
            setIsAutoPlaying(false);
            scrollToIndex(index);
          }} className={`h-2 rounded-full transition-all duration-300 ${activeIndex === index ? 'w-8 bg-[#f5c518]' : 'w-2 bg-[#27272a] hover:bg-[#3f3f46]'}`} aria-label={`Ir al bonus ${index + 1}`} data-id="element-52" />)}
          </div>
        </div>
      </div>
    </section>;
}